import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const useStyles = makeStyles({
    card: {
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        border: "1px solid #E4E7EC",
        padding: "16px 20px",
        minWidth: "180px",
        flex: 1,
    },
    cardHighlighted: {
        backgroundColor: "#1D4179",
        borderRadius: "12px",
        border: "1px solid #1D4179",
        padding: "16px 20px",
        minWidth: "180px",
        flex: 1,
    },
    iconContainer: {
        width: "40px",
        height: "40px",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "12px",
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: "4px",
    },
    label: {
        fontSize: "12px",
        fontWeight: 500,
        color: "#667085",
        marginBottom: "4px",
    },
    labelHighlighted: {
        fontSize: "12px",
        fontWeight: 500,
        color: "rgba(255, 255, 255, 0.8)",
        marginBottom: "4px",
    },
    value: {
        fontSize: "24px",
        fontWeight: 600,
        color: "#101828",
        lineHeight: "32px",
    },
    valueHighlighted: {
        fontSize: "24px",
        fontWeight: 600,
        color: "#FFFFFF",
        lineHeight: "32px",
    },
    subLabel: {
        fontSize: "12px",
        fontWeight: 400,
        color: "#667085",
        marginTop: "4px",
    },
    subLabelHighlighted: {
        fontSize: "12px",
        fontWeight: 400,
        color: "rgba(255, 255, 255, 0.7)",
        marginTop: "4px",
    },
    changeIndicator: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        padding: "2px 8px",
        borderRadius: "16px",
        fontSize: "12px",
        fontWeight: 500,
    },
    positiveChange: {
        backgroundColor: "#ECFDF3",
        color: "#027A48",
    },
    negativeChange: {
        backgroundColor: "#FEF3F2",
        color: "#B42318",
    },
    periodBadge: {
        backgroundColor: "#F2F4F7",
        color: "#344054",
        padding: "2px 8px",
        borderRadius: "16px",
        fontSize: "12px",
        fontWeight: 500,
    },
    arrowIcon: {
        fontSize: "12px",
    },
});

export default function StatCard({
    icon,
    iconBgColor = "#F0F9FF",
    iconColor = "#0BA5EC",
    label,
    value,
    subLabel,
    change,
    showPeriod,
    periodLabel = "Monthly",
    highlighted = false,
}) {
    const classes = useStyles();
    const isPositive = change >= 0;

    const formatValue = (val) => {
        if (typeof val === "number") {
            return val.toLocaleString();
        }
        return val;
    };

    const formatChange = (val) => {
        if (val === undefined || val === null) return null;
        const absVal = Math.abs(val);
        return `${absVal}%`;
    };

    return (
        <Box className={highlighted ? classes.cardHighlighted : classes.card}>
            <Box className={classes.headerRow}>
                <Box
                    className={classes.iconContainer}
                    style={{ backgroundColor: highlighted ? "rgba(255, 255, 255, 0.15)" : iconBgColor }}
                >
                    {icon && React.cloneElement(icon, {
                        style: { color: highlighted ? "#FFFFFF" : iconColor, fontSize: "20px" }
                    })}
                </Box>
                {change !== undefined && change !== null && (
                    <Box
                        className={`${classes.changeIndicator} ${
                            isPositive ? classes.positiveChange : classes.negativeChange
                        }`}
                    >
                        {isPositive ? (
                            <ArrowUpwardIcon className={classes.arrowIcon} />
                        ) : (
                            <ArrowDownwardIcon className={classes.arrowIcon} />
                        )}
                        {formatChange(change)}
                    </Box>
                )}
                {showPeriod && (
                    <Box className={classes.periodBadge}>
                        {periodLabel}
                    </Box>
                )}
            </Box>
            <Typography className={highlighted ? classes.labelHighlighted : classes.label}>
                {label}
            </Typography>
            <Typography className={highlighted ? classes.valueHighlighted : classes.value}>
                {formatValue(value)}
            </Typography>
            {subLabel && (
                <Typography className={highlighted ? classes.subLabelHighlighted : classes.subLabel}>
                    {subLabel}
                </Typography>
            )}
        </Box>
    );
}
